import { ArrowsLeftRightIcon, BookOpenTextIcon, CalendarDotsIcon, ChartBarIcon, ChatsCircleIcon, FileMagnifyingGlassIcon, ListChecksIcon, MegaphoneIcon, PaperPlaneTiltIcon, SignInIcon, UserCircleIcon } from "@phosphor-icons/react";

// The purpose of a playbook, not the platform it happens on (§0.7).
const ICON = {
  "agent-readability": FileMagnifyingGlassIcon,
  "comparison-page": ArrowsLeftRightIcon,
  "creator-post-series": CalendarDotsIcon,
  "community-discussion-points": ChatsCircleIcon,
  "x-reply-queue": ChatsCircleIcon,
  "readme-first-screen": ListChecksIcon,
  "signup-page": SignInIcon,
  "simulated-new-user": UserCircleIcon,
  "release-distribution": MegaphoneIcon,
  "warm-outreach": PaperPlaneTiltIcon,
  "weekly-review": ChartBarIcon,
};

export function PlaybookIcon({ id, size = 16 }: { id: string; size?: number }) {
  const Icon = Object.hasOwn(ICON, id) ? ICON[id as keyof typeof ICON] : BookOpenTextIcon;
  return <Icon size={size} aria-hidden />;
}
